import { RESOUCE_TYPE } from './constant';
export function encodeData(data) {
    return JSON.stringify(data);
}
// export function getUrl(element: HTMLElement & HTMLImageElement & HTMLLinkElement & HTMLScriptElement) {
//   if (!element.tagName) return ''
//   switch (element.tagName.toLowerCase()) {
//     case 'img':
//     case 'script':
//       return element.src
//     case 'link':
//       return element.href
//     case 'xhr':
//       return element.url
//     default:
//       return ''
//   }
// }
export function getResourceType(element) {
    if (!element.tagName)
        return 0;
    switch (element.tagName.toLowerCase()) {
        case 'img':
            return RESOUCE_TYPE.IMG;
        case 'script':
            return RESOUCE_TYPE.JS;
        case 'link':
            return RESOUCE_TYPE.CSS;
        case 'xhr':
            return RESOUCE_TYPE.XHR;
        default:
            return 0;
    }
}
export function setPropToInt(obj) {
    if (obj === void 0) { obj = {}; }
    var data = {};
    // eslint-disable-next-line no-restricted-syntax
    for (var prop in obj) {
        if (typeof obj[prop] === 'number') {
            data[prop] = Math.round(obj[prop]);
        }
        else if (prop !== 'toJSON') {
            data[prop] = obj[prop];
        }
    }
    return data;
}
export function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
export function getUrl(element) {
    if (!element.tagName)
        return '';
    switch (element.tagName.toLowerCase()) {
        case 'img':
        case 'script':
            return element.src;
        case 'link':
            return element.href;
        // case 'xhr':
        //   return element.url
        default:
            return '';
    }
}
XMLHttpRequest;
